import React from 'react';
import { useComplianceSar } from '../hooks/use-compliance-sar.js';
import ComplianceSarPageView from './compliance-sar-page-view.jsx';

function ComplianceSarPageContainer() {
  const state = useComplianceSar();
  return <ComplianceSarPageView {...state} />;
}

export default ComplianceSarPageContainer;
